<template>
  <div class="login">
    <div class="contain">
      <p class="hello" v-if="user.start">Hello {{ user.start.full_name }},</p>
      <h1>Login to your account below.</h1>

      <div class="question">
        <p class="title">Pick up where you left off!</p>
        <div class="inputs">
          <div class="input full">
            <label>Email Address</label>
            <input ref="email" type="email" v-model="user.email" />
          </div>
          <div class="input full">
            <label>Password</label>
            <input ref="password" type="password" v-model="password" />
          </div>
          <div class="btns">
            <button @click="login()" class="btn">Login</button>
          </div>
          <button @click="forgotPassword()" class="btn text-btn back">forgot password</button>
          <p v-if="errors.length" class="errors">
            Please enter a
            <span v-for="(error, index) in errors">
              {{ error
              }}{{ index + 1 == errors.length ? "." : ", " }}
            </span>
          </p>
          <p class='errors'>{{login_error}}</p>
          <p v-if="password_reset_success" class="success">Password Reset Sent!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, auth } from "@/config/firebaseInit";
import firebase from "firebase";

export default {
  name: "login",
  data() {
    return {
      user: {
        email: null
      },
      password: null,
      errors: [],
      login_error: null,
      password_reset_success: false
    };
  },
  methods: {
    login() {
      if (this.validate()) {
        let vm = this;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.user.email, this.password)
          .then(data => {
            let uid = data.user.uid;
            db.collection("user")
              .where("uid", "==", uid)
              .get()
              .then(snap => {
                let user = snap.docs[0].data();
                user.id = snap.docs[0].id;
                this.$store.commit("setNewUser", user);
                this.$store.commit("setApplicationApprovalPhase", user.status);
                this.goTo("/dashboard");
              });
          })
          .catch(function(error) {
            vm.login_error = error.message;
          });
      }
    },
    validate() {
      let valid = true;
      this.errors = [];
      this.error = null;
      if (this.user.email) {
        if (!this.validateEmail()) {
          valid = false;
          this.errors.push("valid Email");
        }
      } else {
        valid = false;
        this.errors.push("valid Email");
      }

      if (!this.password) {
        valid = false;
        this.errors.push("valid Password");
        this.$refs.password.classList.add("error");
      } else {
        this.$refs.password.classList.remove("error");
      }
      return valid;
    },
    validateEmail() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.user.email.toLowerCase())) {
        this.$refs.email.classList.remove("error");
        return true;
      } else {
        this.$refs.email.classList.add("error");
        return false;
      }
    },
    forgotPassword() {
      let valid = true;
      this.errors = [];
      if (this.user.email) {
        if (!this.validateEmail()) {
          valid = false;
          this.errors.push(
            "valid Email so we can send you an reset password link"
          );
        }
      } else {
        valid = false;
        this.errors.push(
          "valid Email so we can send you an reset password link"
        );
      }
      if (valid) {
        let vm = this;
        auth
          .sendPasswordResetEmail(this.user.email)
          .then(function() {
            vm.password_reset_success = true;
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.login {
  height: auto;
  min-height: 100vh;
  width: 100%;
  .contain {
    max-width: 650px;
    .hello {
      margin-bottom: 10px;
    }
    .errors {
      margin-top: 20px;
    }
    .success {
      width: 100%;
      margin-top: 20px;
      color: #5bc575;
    }
  }
}
</style>
